/*
 * @Author: error: git config user.name && git config user.email & please set dead value or install git
 * @Date: 2022-08-11 16:45:24
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @LastEditTime: 2022-08-31 15:54:24
 * @FilePath: \ioc_base\src\modules\workShop\const\shopManageTable.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { Dic } from "$utils";
export const tableOption = function (that) {
  return {
    view: "详情",
    page: true,
    selection: false,
    index: true,
    indexLabel: "序号",
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: "left",
    size: "small",
    maxHeight: "100%",
    labelWidth: "100px",
    menuAlign: "center",
    searchMenuSpan: 6,
    searchBtn: false,
    emptyText: "暂无数据",
    column: [
      {
        label: "车间名称",
        prop: "workShopName",
        search: true,
        clearable: true
      },
      {
        label: "车间负责人",
        prop: "directorPersonnelName",
        search: true,
        clearable: true
      },
      {
        label: "班组负责人",
        prop: "workShopMonitorPersonnelName",
        search: true,
        clearable: true,
        hide:true,
      },
      {
        label: "班组负责人",
        prop: "workShopMonitorPersonnelList",
        // search: true,
        // clearable: true,
        formatter: (row, info) => {
          return info
            .map((item) => {
              return item.personnelName;
            })
            .join(",");
        }
      },
      {
        label: "值班人员",
        prop: "workShopPersonnelList",
        search: true,
        clearable: true,
        formatter: (row, info) => {
          return info
            .map((item) => {
              return item.personnelName;
            })
            .join(",");
        }
      },
      {
        label: "车间说明",
        prop: "desc"
      }
    ]
  };
};
export default tableOption;
